import script from "./DatasetMoveDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./DatasetMoveDialog.vue?vue&type=script&setup=true&lang=js"

import "./DatasetMoveDialog.vue?vue&type=style&index=0&id=8bce4556&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8bce4556"]])

export default __exports__